import member1 from "./assets/img/profile.jpg";
import member2 from "./assets/img/YousufHashmi.png";
import member3 from "./assets/img/AbdullahMaqbool.jpg";
import member4 from "./assets/img/member4.jpg";
import member5 from "./assets/img/ReyhanFirminda.png";
import member6 from "./assets/img/Amna Ghafoor.jpg";

import animaker from "./assets/img/animaker-screenshot.png";
import buyCex from "./assets/img/buycex-screenshot.png";
import signature from "./assets/img/signature-screenshot.png";
import dettydec from './assets/img/dettydec-Screenshot.png';
import ambiwance from './assets/img/ambiwance-Screenshot.png';
import cyberwise from './assets/img/cyberwise-Screenshot.png';
import modena from './assets/img/modena-Screenshot.png';
import holidaysunlocked from "./assets/img/holiday-Screenshot.png";
import promptgraphy from "./assets/img/promptgraphy-Screenshot.png";
import stockswishlist from "./assets/img/stocksplus-Screenshot.png";
import neptune from "./assets/img/naptune-Screenshot.png";
import setium from "./assets/img/seospark-Screenshot.png";
import infused from "./assets/img/infused-Screenshot.png";

export const projects = [
  {
    id: 0,
    name: "Holidays Unlocked",
    detail: "(Travel Deals & Booking Platform)",
    category: "Travel / Booking",
    keys: ["travel", "holidays", "booking", "flights", "hotels", "deals"],
    desc: "Holidays Unlocked is a modern travel booking platform that lets users search and book flights, hotel stays, car rentals, and activities worldwide with exclusive deals, flexible cancellations, and real-time pricing. Tech stacks: React.js • Next.js • Tailwind CSS • API integrations (flights/hotels/car data) • Responsive design • Newsletter/Forms handling.",
    link: "https://holidaysunlocked.com/",
    img: holidaysunlocked,
    type: "Client",
  },
  {
    id: 1,
    name: "Cyber Wise",
    detail: "(A Cybersecurity Platform)",
    category: "Application",
    keys: ["cybersecurity", "security", "training", "consultations", "phishing"],
    desc: "CyberWise is a comprehensive cybersecurity platform that protects digital assets and empowers teams with expert consultations, realistic phishing simulations, in-depth team training, 24/7 real-time monitoring, thorough security audits, and compliance support tailored to business needs. Tech stacks: React.js • Next.js • Tailwind CSS • API integrations • Responsive design • Counter animations • Forms/Newsletter handling.",
    link: "https://cyber-wise-fyp.vercel.app/",
    img: cyberwise,
    type: "Client",
  },
  {
    id: 2,
    name: "Detty December",
    detail: "(An Event Discovery Platform)",
    category: "Application",
    keys: ["events", "concerts", "festivals", "parties", "lifestyle"],
    desc: "Detty December is an event discovery platform that helps users explore the best parties, concerts, festivals, and lifestyle experiences. It brings together curated events, venues, blogs, and exclusive perks. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Event listing & filtering • Dynamic content • Forms/Newsletter handling.",
    link: "https://dettydecember-nine.vercel.app/",
    img: dettydec,
    type: "Client",
  },
  {
    id: 3,
    name: "BuyCex",
    detail: "(A Crypto Exchange Website)",
    category: "Crypto",
    keys: ["business", "crypto", "buycex", "bitcoin", "exchange"],
    desc: "BuyCex is a publicly owned cryptocurrency exchange platform that enables users to trade top coins, participate in presales, earn rewards, and explore market movements with features like top gainers/losers lists, new listings, and seamless trading interfaces. Tech stacks: React.js • Next.js • Tailwind CSS • API integrations (45+ backend endpoints) • Authentication & payment gateways • Responsive design • Real-time data handling.",
    link: "https://www.buycex.com/",
    img: buyCex,
    type: "Client",
  },
  {
    id: 4,
    name: "Promptgraphy",
    detail: "(BER AI – AI-Powered Content Creation)",
    category: "Application",
    keys: ["AI", "content", "images", "video", "promptgraphy", "BER AI"],
    desc: "Promptgraphy (BER AI) is an all-in-one AI-powered content creation platform that lets users generate high-quality text, stunning images, dynamic videos, and edit photos effortlessly. It supercharges workflows for content creators, marketers, and businesses with tools for SEO-friendly writing, hyperrealistic visuals, text-to-video conversion, image animation, and advanced photo enhancements. Tech stacks: React.js • Next.js • Tailwind CSS • AI model integrations (ChatGPT, Claude, Gemini, Llama, FLUX, Dream Machine) • Responsive design.",
    link: "https://ber-ai.vercel.app/",
    img: promptgraphy,
    type: "Client",
  },
  {
    id: 5,
    name: "Modena Apartments",
    detail: "(A Real Estate Website)",
    category: "Business",
    keys: ["real estate", "apartments", "property", "investment"],
    desc: "Modena Apartments is a sleek real estate showcase platform highlighting modern investment apartments in Donovaly, offering carefree ownership with property management, passive income potential, and stunning nature surroundings. It includes detailed investment info, property features, gallery views, and easy contact/booking options. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Interactive gallery & counters • Forms/contact handling.",
    link: "https://new-project-seven-gray.vercel.app/",
    img: modena,
    type: "Client",
  },
  {
    id: 6,
    name: "Ambiance Wax",
    detail: "(An Ecommerce Website)",
    category: "Ecommerce",
    keys: ["wax", "ecommerce", "lifestyle", "candles", "home"],
    desc: "Ambiance Wax is a modern e-commerce platform showcasing premium wax products, scented candles, home ambiance items, and lifestyle goods. It features elegant product displays, curated collections, seamless browsing, and a user-friendly shopping experience. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Product grids & collections • E-commerce features (cart/browse) • Dynamic content.",
    link: "https://ambiancewax-nine.vercel.app/",
    img: ambiwance,
    type: "Client",
  },
  {
    id: 7,
    name: "Email Signature Generator",
    detail: "(A Full-Stack Website)",
    category: "Business",
    keys: ["signature", "email", "tool", "business"],
    desc: "Email Signature Generator is a powerful Next.js full-stack tool that lets users create professional, branded email signatures in seconds. It features an intuitive editor for adding name, title, company, contact info, social links, logo/avatar upload, custom fields, color themes, and multiple templates, with real-time preview and easy HTML copy for Gmail, Outlook, Apple Mail, and more. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Real-time preview • File upload (logo/avatar) • Dynamic forms & templates • HTML generation.",
    link: "https://signature-generator-orpin.vercel.app/",
    img: signature,
    type: "Client",
  },
  {
    id: 8,
    name: "Stocks Wishlist",
    detail: "(Finance Tracking App)",
    category: "Application",
    keys: ["stocks", "finance", "watchlist", "trading", "portfolio"],
    desc: "Stocks Wishlist is a modern finance tracking app that lets users create and manage personalized stock watchlists, monitor market performance, track price changes, and stay updated on favorite investments. It offers intuitive search for stocks, real-time or near-real-time data views, customizable lists, and easy addition/removal of symbols. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • API integrations (stock data feeds) • Dynamic lists & tables • Charts/visualizations • Forms/search handling.",
    link: "https://stockswishlist.vercel.app/",
    img: stockswishlist,
    type: "Client",
  },
  {
    id: 9,
    name: "Animaker",
    detail: "(A Business Website)",
    category: "Business",
    keys: ["business", "animaker", "corporate", "advertising", "animation", "video"],
    desc: "Animaker is a dynamic, animated landing page showcasing AI-powered video and animation creation tools. It delivers a vibrant user experience with lively animations, effortless content generation features (text-to-video, 2D animation, live-action elements), hero highlights for studio-quality results, and intuitive sections for non-designers and professionals. Tech stacks: React.js • Tailwind CSS • GSAP/Framer Motion (for animations) • Responsive design • Dynamic hero & sections • Interactive elements.",
    link: "https://animakerjohn.vercel.app/",
    img: animaker,
    type: "Client",
  },
  {
    id: 10,
    name: "Neptune SaaS",
    detail: "(SaaS Landing Page)",
    category: "Business",
    keys: ["SaaS", "landing", "startup", "agency", "template"],
    desc: "Neptune SaaS is a premium, modern landing page template designed for SaaS platforms, startups, and agencies. It delivers a standout, professional website with sleek blue tones, dynamic sections for product features, benefits showcase, pricing plans, customer testimonials, integration highlights, and clear calls-to-action like 'Get Started' or 'Book a Demo'. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Animations/transitions • Hero & feature grids • Pricing tables • Testimonials carousel.",
    link: "https://neptune-saas-web.vercel.app/",
    img: neptune,
    type: "Client",
  },
  {
    id: 11,
    name: "SEO SPARK",
    detail: "(SaaS Landing Page)",
    category: "Business",
    keys: ["SEO", "SaaS", "landing", "startup", "digital"],
    desc: "SEO SPARK is a sleek, modern SaaS landing page template or demo designed for startups, tools, or digital products. It features a professional hero section with compelling headline and CTA, feature highlights in cards or grids, benefit-focused copy, testimonials or trust signals, pricing options, and intuitive navigation to showcase product value and drive user sign-ups or demos. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Hero animations/transitions • Feature grids & cards • CTA buttons/forms.",
    link: "https://setium.vercel.app/",
    img: setium,
    type: "Client",
  },
  {
    id: 12,
    name: "Infused",
    detail: "(Digital Agency Landing Page)",
    category: "Business",
    keys: ["agency", "digital", "creative", "branding", "marketing"],
    desc: "Infused is a sleek, modern landing page for a digital agency or creative services platform, empowering businesses to elevate their brand with infused strategies, innovative solutions, and high-impact web experiences. It features a compelling hero section with bold taglines, services showcase (e.g., web design, marketing, development), benefit highlights, client testimonials or case studies, seamless CTAs like 'Get Started' or 'Contact Us', and a clean, professional layout. Tech stacks: React.js • Next.js • Tailwind CSS • Responsive design • Hero animations/transitions • Services/feature grids • Testimonials carousel • Forms/contact handling.",
    link: "https://infused-delta.vercel.app/",
    img: infused,
    type: "Client",
  },
];


const team = [
  {
    id: 0,
    name: "Muhammad Zeshan",
    info: "Full Stack Developer (React.js/Next.js/Web3.js)",
    link: "https://www.linkedin.com/in/muhammad-zeshan-b84421263/",
    img: member1,
  },
  {
    id: 1,
    name: "Yousaf Hashmi",
    info: "Backend Developer (FastAPI,Jango)",
    link: "https://www.linkedin.com/in/yousaf-hashmi-4372481b1/",
    img: member2,
  },
  {
    id: 2,
    name: "Abdullah Maqbool",
    info: "MERN Stack Developer (React/Next.js)",
    link: "https://www.linkedin.com/in/abdullah-maqbool/",
    img: member3,
  },
  {
    id: 3,
    name: "Muhammad Tayyab",
    info: "Frontend Developer (React.js/Next.js/Angular.js)",
    link: "https://www.linkedin.com/in/muhammad-tayyab-bb27a4250/",
    img: member4,
  },
  {
    id: 4,
    name: "Reyhan Firminda",
    info: "Web/Graphic Designer (Figma/Canva/Photoshop)",
    link: "https://www.linkedin.com/in/reyhanfirmanda/",
    img: member5,
  },
  {
    id: 5,
    name: "Amna Ghafoor",
    info: "SEO Expert (SEO/SEM/SMO/Content Writing)",
    link: "https://www.linkedin.com/in/amna-ghaffor-bbaa66270/",
    img: member6,
  },
];

export default team;
